import { useEffect, useState } from "react";
import { useTelegram } from "../../context/TelegramContext";
import { getPremium, getProfile } from "../../api/mainApi";
import Premium from "./Premium";

const REG_DISCOUNT_MS = 48 * 60 * 60 * 1000;

function isPremiumValue(value) {
  if (value === "true") return true;
  const num = parseInt(value, 10);
  return !isNaN(num) && num > 0;
}

export default function PremiumPopupManager() {
  const tg = useTelegram();
  const [showPremium, setShowPremium] = useState(false);

  useEffect(() => {
    if (!tg?.initData) return;
    if (sessionStorage.getItem("premiumPopupShown") === "true") return;

    const lsPremium = localStorage.getItem("premium");
    if (isPremiumValue(lsPremium)) return;

    let cancelled = false;

    (async () => {
      try {
        const data = await getPremium();
        if (cancelled) return;

        const prem = data?.premium;
        if (prem === true || (typeof prem === "number" && prem > 0)) {
          localStorage.setItem("premium", prem);
          return;
        }

        let globalDeadline = 0;
        if (data?.discount_end_date) {
          const ts = Number(data.discount_end_date);
          if (!isNaN(ts) && ts > 0) {
            globalDeadline = ts;
            localStorage.setItem("discount_end_date", ts);
          }
        } else {
          const saved = Number(localStorage.getItem("discount_end_date"));
          if (!isNaN(saved) && saved > 0) globalDeadline = saved;
        }

        let regTs = parseInt(localStorage.getItem("reg_date"), 10);
        if (!regTs || isNaN(regTs)) {
          try {
            const profile = await getProfile();
            if (cancelled) return;
            if (profile?.reg_date) {
              const ts = Number(profile.reg_date);
              if (!isNaN(ts) && ts > 0) {
                regTs = ts;
                localStorage.setItem("reg_date", ts);
              }
            }
          } catch (err) {
            console.error("PremiumPopupManager: getProfile failed", err);
          }
        }

        const individualDeadline = regTs ? regTs + REG_DISCOUNT_MS : 0;
        const now = Date.now();
        const hasIndividual = individualDeadline > 0 && now < individualDeadline;
        const hasGlobal = globalDeadline > 0 && now < globalDeadline;

        if (hasIndividual || hasGlobal) {
          if (!cancelled) {
            setShowPremium(true);
            sessionStorage.setItem("premiumPopupShown", "true");
          }
        }
      } catch (err) {
        console.error("PremiumPopupManager: getPremium failed", err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [tg]);

  if (!showPremium) return null;
  return <Premium showPremium={showPremium} setShowPremium={setShowPremium} />;
}